import PropTypes from 'prop-types';
import React, { Component } from 'react';
import moment from 'moment-timezone';
import Datetime from 'react-datetime';

import Dropdown from '../Dropdown';
import GenericFormItem from '../GenericFormItem';
import { localize } from '../../i18n';

class DateTimeField extends Component {
  constructor(props) {
    super(props);

    let val = moment(this.props.val || new Date());
    if (this.props.timezone) {
      val = val.tz(this.props.timezone);
    }
    if (this.props.edit === true) {
      if (this.props.roundTo) {
        const remainder = this.props.roundTo - (val.get(this.props.nearest) % this.props.roundTo);
        if (remainder !== this.props.roundTo) {
          val = val.add(remainder, this.props.nearest);
        }
      }
    }

    this.state = {
      val,
      showSelector: false,
    };
  }

  componentDidMount() {
    if (this.props.val === null && this.props.setDefault === true) {
      this.props.onSave(this.props.name, this.state.val.toISOString());
    }
  }

  onChange(val) {
    let allowChange = true;
    if (this.props.allowPastDates === false) {
      let now = moment();
      if (this.props.timezone) {
        now = now.tz(this.props.timezone);
      }
      if (now.diff(val) > 0) {
        allowChange = false;
      }
    }
    if (allowChange === true && this.props.roundTo) {
      const remainder = this.props.roundTo - (val.get(this.props.nearest) % this.props.roundTo);
      if (remainder !== this.props.roundTo) {
        allowChange = false;
      }
    }
    if (allowChange === true) {
      this.setState({
        val,
      });
    }
  }

  onSave(name, val) {
    this.setState({
      showSelector: false,
    }, () => {
      let saveVal = val;
      if (this.props.roundTo) {
        const remainder = this.props.roundTo - (saveVal.get(this.props.nearest) % this.props.roundTo);
        if (remainder !== this.props.roundTo) {
          saveVal = saveVal.add(remainder, this.props.nearest);
        }
      }
      this.props.onSave(name, saveVal.toISOString());
    });
  }

  handleOpenModal() {
    this.setState({
      showSelector: true,
    });
  }

  render() {
    const {
      name,
      label,
      edit,
    } = this.props;
    const {
      val,
      showSelector,
    } = this.state;
    let hintText = '';
    let value = val !== null ? val.locale(moment.locale()).format('MM/DD/YYYY hh:mm A') : val;
    if (edit === true) {
      if (this.props.roundTo) {
        hintText = this.props.t('Rounded to the nearest {roundTo} {nearest}', { roundTo: this.props.roundTo, nearest: this.props.nearest });
      }
      value = (
        <Dropdown
          size="mobile"
          href="#datepicker-popup"
          label={val.format('MM/DD/YYYY hh:mm A')}
          className="datetime-picker"
          position="top-center"
          request={(showSelector === true) ? 'open' : 'close'}
          onChange={(changeShowSelector) => {
            this.setState({
              showSelector: changeShowSelector,
            });
          }}
          hideTrigger
        >
          <div className="md-card">
            <div className="md-head">
              <h3 className="md-card-head-text uk-text-center">{val.format('MM/DD/YYYY hh:mm A')}</h3>
            </div>
            <div className="md-card-content">
              <Datetime
                className="datetime-picker"
                value={val}
                onChange={(changeValue) => {
                  this.onChange(changeValue);
                }}
                input={false}
                locale={moment.locale()}
                hinttext={hintText}
                timeConstraints={{ minutes: { step: 10 } }}
              />
              <div className="save-btn-holder">
                <button
                  className="md-btn md-btn-wave-light waves-effect waves-button waves-light md-btn-primary"
                  onClick={() => this.onSave(name, this.state.val)}
                >
                  {this.props.t('Save')}
                </button>
              </div>
            </div>
          </div>
        </Dropdown>
      );
    }

    return (
      <GenericFormItem label={label}>
        {value}
      </GenericFormItem>
    );
  }
}

DateTimeField.propTypes = {
  name: PropTypes.string.isRequired,
  val: PropTypes.string,
  timezone: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  edit: PropTypes.bool,
  // eslint-disable-next-line
  setDefault: PropTypes.bool,
  onSave: PropTypes.func,
  roundTo: PropTypes.number,
  nearest: PropTypes.string,
  allowPastDates: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

DateTimeField.defaultProps = {
  onSave: () => { },
  setDefault: false,
  roundTo: null,
  nearest: 'seconds',
  allowPastDates: true,
};

export default localize(DateTimeField);



// WEBPACK FOOTER //
// ./src/components/FormConfigs/DateTimeField.js